<template>
  <div :class="['exr-view exr-theme-' + theme, 'exr-' + type.template]">
    <div class="exr-type-info">{{ exercise.id }}.&nbsp;{{ type.name }}</div>
    <component :is="type.template" :entity="exrData" :type="type" :theme="theme" ref="exr"
               class="exr-content"></component>
    <div v-if="exercise.grammar" class="grammar-line-preview">
      <ruby>{{ exercise.grammar.text }}
        <rt>{{ exercise.grammar.pinyin }}</rt>
      </ruby>
      <div v-if="exercise.grammar.explain" class="pre-wrap">{{ exercise.grammar.explain }}</div>
    </div>
  </div>
</template>

<script>
import xzt from './views/XztView'
import dct from './views/DctView'
import pxt from './views/PxtView'
import xctk from './views/XctkView'
import xktc from './views/XktcView'
import lyt from './views/LytView'
import xsd from './views/XsdView'
import dwtk from './views/DwtkView'
import pdt from './views/PdtView'
import zct from './views/ZctView'
import dht from './views/DhtView'
import ktsh from './views/KtshView'
import hdwt from './views/HdwtView'
import cache from './../../js/cache.js'
import PinyinPreview from '../PinyinPreview'

export default {
  name: 'ExercisePreview',
  components: {xzt, dct, pxt, xctk, xktc, lyt, xsd, dwtk, pdt, zct, dht, ktsh, hdwt, PinyinPreview},
  props: {
    eid: [Number, String],
    entity: {
      type: Object,
      default: () => {
        return {}
      }
    },
    types: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: 'card'
    }
  },
  data() {
    return {
      type: {},
      exercise: {}
    }
  },
  watch: {
    eid: {
      handler(id) {
        this.fetchModel(id);
      },
      immediate: true
    },
    entity: {
      handler(exr) {
        this.handleType(exr);
        this.exercise = exr;
      },
      immediate: true
    }
  },
  computed: {
    exrData() {
      const exr = {...this.exercise};
      const dataJson = exr.data || (exr.data_json ? JSON.parse(exr.data_json) : null);
      delete exr.data;
      Object.assign(exr, dataJson);
      return exr
    }
  },
  methods: {
    fetchModel(id) {
      if (!id || (this.exercise && this.exercise.id === id)) {
        return;
      }
      this.$http.get(this.$urls.exercise_view, {
        params: {id, expand: 'type'}
      }).then(res => {
        // console.dir(res);
        const exr = res.data;
        if (!exr.data && exr.data_json) {
          exr.data = JSON.parse(exr.data_json);
        }
        this.handleType(exr);
        this.exercise = exr;
      });
    },
    handleType(exr) {
      if (!exr || (this.exercise && this.exercise.id === exr.id)) {
        return;
      }
      if (exr.type) {
        this.type = exr.type
      } else if (this.types[exr.tid]) {
        this.type = this.types[exr.tid]
      } else {
        cache.getExerciseType(exr.tid).then((res) => {
          this.type = res
        })
      }
    }
  }
}
</script>
